@if (loaded) {
  <div>
    @if (hasUtbyteInlastTid()) {
      <div>
        <rask-span class="utbytelabelfontsize" [ngClass]="spanColor$ | async" size="10">{{ utbyteInlastFran + " hämtad: " + getUtbyteInlastTid() | uppercase }}</rask-span>
      </div>
    }
    <div class="position-relative">
      <div class="d-flex">
        <rask-button color="secondary" [disabled]="disabled" (click)="getBeraknatUtbyte()" class="mt-0">Hämta beräknat utbyte</rask-button>
        <rask-virkeskop-validation-icon-popover [messageId]="messageId" [entityGuid]="entityGuid"></rask-virkeskop-validation-icon-popover>
      </div>
      @if (showUtbytePanel) {
        <div #utbytePanel class="utbyte-panel">
          <rask-button color="tertiary" (click)="getSnabbkalkyl()">Hämta snabbkalkyl</rask-button>
          <rask-button color="tertiary" (click)="getDirektUtbyte()">Hämta direktutbyte</rask-button>
        </div>
      }
    </div>
  </div>
}